import React from 'react';
import { WebGameMainCont, gameConfigStore } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import RightColumn from '../../common/rightColumn';
import LeftColumn from '../../common/leftColumn';
import { useVisibilityChange } from '../../../hooks/useVisibilityChange';
import CenterColumn from '../../web/centerColumn';
import gameLogo from '../../../assets/images/logo.png';
import logo747 from '../../../assets/images/747/gameTypeLogo.png';
import logoTurkish from '../../../assets/images/turkishPartner/fishing-logo-for-turkish-partner.png';
import playForRealPopupImgSrc from '../../../assets/images/core/play-for-real-popup.png';
import { brandedGameIds } from '../../../enums/brandedPartners';

export const WebGame = observer(() => {
  useVisibilityChange();
  const { gameId } = gameConfigStore;
  const brandedLogos = {
    [brandedGameIds.betfair]: null,
    [brandedGameIds['747']]: logo747,
    [brandedGameIds.turkish]: logoTurkish,
  };

  return (
    <WebGameMainCont
      isShowBogLineLobby
      lobbyLogoImageSrc={brandedLogos[gameId] || gameLogo}
      hasGameTypeLoading
      playForRealPopupImgSrc={playForRealPopupImgSrc}
    >
      <LeftColumn />
      <CenterColumn />
      <RightColumn />
    </WebGameMainCont>
  );
});
